import Swal from 'sweetalert2'

import { fetchConToken, fetchSinToken } from "../helpers/fetch";
import { types } from "../types/types";

export const productStartAddNew= ( product ) => {
    return async(dispatch ,getState) => {

        const { uid, name } = getState().auth

        try {
            
            const resp = await fetchConToken('products',product,'POST');
            const body = await resp.json();

            if( body.ok ){
                product.id = body.product.id
                product.user ={
                    _id: uid,
                    name
                }

                
                dispatch( productAddNew( product ) )
            }

        } catch (error) {
            console.log(error)
        }


       
    }
}


const productAddNew = ( product ) =>({
    type: types.productAddNew,
    payload: product
})


export const productStartUpdate = ( product ) => {
    return async(dispatch) => {

       
        try {
             const resp = await fetchConToken(`products/${ product.id }`,product,'PUT');
             const body = await resp.json();

             if(body.ok){
                 dispatch(productUpdated(product))
             }else{
                Swal.fire('Error',body.msg,'error')
             }
            
        } catch (error) {
            console.log(error)
        }

    }
}


const productUpdated = ( product ) =>({
    type: types.productUpdate,
    payload: product
})


export const productStartDeleted = (item) =>{
    return async(dispatch) =>{

        try {
            
            const resp = await fetchConToken( `products/${ item.id }`, {}, 'DELETE' );
            const body = await resp.json();

            if(body.ok){
                dispatch(productDeleted(item))
            }else{
               Swal.fire('Error',body.msg,'error')
            }
           
            
        } catch (error) {
            console.log(error)
        }

    }
}
 const productDeleted = ( product ) =>({
    type: types.productDelete,
    payload: product
})

export const productStartLoading = () => {
    return async(dispatch) =>{

       try {
            const resp = await fetchSinToken('products')
            const body = await resp.json()

            const product = body.products

            dispatch(productLoaded(product))
           
       } catch (error) {
           console.log(error)
       }

    }
}


const productLoaded = ( product )=>({
    type: types.productLoaded,
    payload: product
})